import React from 'react';
import TabButton from 'components/Button/TabButton/TabButton';
import { DisplayMode } from 'components/Experiment/constants';
import {
  useSetCanvasNavigationTapDisplayMode,
  useCanvasNavigationTabDisplayMode,
} from 'redux/hooks/common';

interface Props {
  buttonsToShow?: DisplayMode[];
}

const NavigationSidebar = (props: Props) => {
  const {
    buttonsToShow = [
      DisplayMode.WELLINGREDIENT,
      DisplayMode.IMAGE,
      DisplayMode.DESIGN,
      DisplayMode.SCORE,
    ],
  } = props;
  const _SetCanvasTapDisplayMode = useSetCanvasNavigationTapDisplayMode();
  const canvasTabDisplayMode = useCanvasNavigationTabDisplayMode();
  const checkVisibility = (mode: DisplayMode) =>
    buttonsToShow.includes(mode) ? 'block' : 'hidden';
  return (
    <>
      <div
        id='canvas-magnifyingrectangle-layer '
        onClick={() => _SetCanvasTapDisplayMode(DisplayMode.DESIGN)}
        className={`${checkVisibility(DisplayMode.DESIGN)}`}
      >
        <TabButton
          IconProps={{ name: 'Design' }}
          titleTip={'Design'}
          active={canvasTabDisplayMode === DisplayMode.DESIGN}
        />
      </div>
      <div
        id='canvas-magnifyingrectangle-checkvisibility-image'
        onClick={() => _SetCanvasTapDisplayMode(DisplayMode.IMAGE)}
        className={`${checkVisibility(DisplayMode.IMAGE)}`}
      >
        <TabButton
          IconProps={{ name: 'Images' }}
          titleTip={'Image'}
          active={canvasTabDisplayMode === DisplayMode.IMAGE}
        />
      </div>
      <div
        id='canvas-magnifyingrectangle-checkvisibility-wellingredient'
        onClick={() => _SetCanvasTapDisplayMode(DisplayMode.WELLINGREDIENT)}
        className={`${checkVisibility(DisplayMode.WELLINGREDIENT)}`}
      >
        <TabButton
          IconProps={{ name: 'IngredientInfo' }}
          titleTip={'Well Ingredients'}
          active={canvasTabDisplayMode === DisplayMode.WELLINGREDIENT}
        />
      </div>
      <div
        id='canvas-magnifyingrectangle-checkvisibility-score'
        onClick={() => _SetCanvasTapDisplayMode(DisplayMode.SCORE)}
        className={`${checkVisibility(DisplayMode.SCORE)}`}
      >
        <TabButton
          IconProps={{ name: 'Scores' }}
          titleTip={'Scores'}
          active={canvasTabDisplayMode === DisplayMode.SCORE}
        />
      </div>
    </>
  );
};

export default NavigationSidebar;
